module.exports = __webpack_public_path__ + "assets/img/news (13).6ae91ae0.png";